import React, { useCallback } from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import Clickable from '@move-ui/clickable';
import { ArrowDownIcon, ArrowUpIcon } from '@move-ui/icons-asset-catalog';
import styles from './Section.module.css';
const Section = ({ className, sectionKey, onActivate, active, onClick, headline, preview, children }) => {
    const handleClick = useCallback((value) => {
        onActivate(value);
        if (typeof onClick !== 'undefined') {
            onClick();
        }
    }, [onClick, onActivate]);
    return (React.createElement("div", { className: cx(styles.section, className) },
        React.createElement("div", { className: styles.triggerWrapper },
            React.createElement(Clickable, { className: styles.sectionTrigger, onClick: handleClick },
                React.createElement("div", { className: styles.sectionHeadline },
                    headline,
                    !active && React.createElement(ArrowDownIcon, null),
                    active && React.createElement(ArrowUpIcon, null)),
                preview && (React.createElement(Text, { size: TextSize.S, color: "neutral-100", "data-testid": `${sectionKey}-preview`, className: cx(styles.sectionPreview, {
                        [styles.sectionPreviewVisible]: !active
                    }) }, preview)))),
        React.createElement("div", { className: cx(styles.content, {
                [styles.contentActive]: active
            }), "data-testid": sectionKey }, children)));
};
export default Section;
//# sourceMappingURL=Section.js.map